import token, { tokenToVars } from '../token';
import Descriptions from './descriptions';

export { Descriptions };
export default tokenToVars(Descriptions, token);
